export const COOKIE_OK = "COOKIE_OK"
export const COOKIE_DECLINE = "COOKIE_DECLINE"
export const ROUTER_LOCATION_CHANGE = "ROUTER_LOCATION_CHANGE"
export const INVENTORY_ITEM_SCRAPED = "INVENTORY_ITEM_SCRAPED"
